import React, { useRef, memo } from 'react';
import { useClickAway } from 'react-use';

import { useSrcrollEvent } from '../../functions';

import './OptionsPopUp.css';
import { OPTIONS_POP_UP_ITEMS_LIST } from '../../constants';

const OptionsPopUp = ({ left, top, poligonListRef, onClick }) => {
  const optionPopUpRef = useRef(null);
  useSrcrollEvent(poligonListRef);

  useClickAway(optionPopUpRef, () => {
    onClick(null);
  });

  return (
    <div
      className="OptionsPopUp"
      style={{
        left,
        top
      }}
      ref={optionPopUpRef}
    >
      <ul className="OptionsPopUp_Items">
        {OPTIONS_POP_UP_ITEMS_LIST.map((item) => (
          <li className="OptionsPopUp_Item" key={item} onClick={() => onClick(item)}>
            {item}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default memo(OptionsPopUp);
